import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../services/localization.service';
import { LocalizationReplacementsModel } from '../models/localization-replacements.model';
import { LocalizeStringModel } from '../models/localize-string.model';

/* eslint-disable @typescript-eslint/naming-convention */
@Pipe({
    name: 'localize',
    pure: true,
    standalone: false
})
export class LocalizationPipe implements PipeTransform {

    constructor(private localizationService: LocalizationService) {}

    /**
     * Performs a transform operation on a localization key to get the string for the current language
     *
     * @param text Either a key to be looked up from a cache/ backend / file localizationMap or a string to be returned
     * @param args (OPTIONAL) Parameters to replace arguments in text
     *
     * @returns Translated string
     */
    transform(text: string|LocalizeStringModel, args: LocalizationReplacementsModel = { '' : ''}): string  {
        if (text && typeof text !== 'string' && text.key) {
            const localized: LocalizeStringModel = text as LocalizeStringModel;
            return this.localizationService.transform(localized.key, localized.args);
        }
        return this.localizationService.transform(text as string, args);
    }
}
